import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-modal',
  templateUrl: './app-modal.component.html',
  styleUrls: ['./app-modal.component.scss']
})
export class AppModalComponent implements OnInit {

  public isOpen = false;

  constructor() {


   }

  ngOnInit(): void {
  }

}
